"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const styles_1 = require("@material-ui/core/styles");
const Avatar_1 = __importDefault(require("../Avatar"));
const Container_1 = __importDefault(require("../Container"));
const Typography_1 = __importDefault(require("../Typography"));
const Grid_1 = __importDefault(require("../Grid"));
const styles_2 = __importDefault(require("./styles"));
exports.UserBadge = ({ avatar, name, size, title, invert, center, children, classes, className, style }) => {
    const UserBadgeAvatar = react_1.default.isValidElement(avatar) ? (avatar) : (react_1.default.createElement(Avatar_1.default, { name: name, size: size, src: avatar }));
    // if 'auto' then center if children are null
    const shouldCenter = center === true || (center === 'auto' && !children);
    const alignItems = shouldCenter ? 'center' : 'flex-start';
    const { title: titleClass } = classes, gridClasses = __rest(classes, ["title"]);
    const userTitle = title && (react_1.default.createElement(Typography_1.default, { inline: true, className: titleClass, variant: 'h5' }, title));
    return (react_1.default.createElement(Grid_1.default, { spacing: 16, alignItems: alignItems, classes: gridClasses, className: className, style: style },
        react_1.default.createElement(Grid_1.default.Item, null, UserBadgeAvatar),
        react_1.default.createElement(Grid_1.default.Item, null,
            react_1.default.createElement(Typography_1.default, { inline: true, variant: 'h5', invert: invert, weight: 'semibold' }, name),
            userTitle,
            children && react_1.default.createElement(Container_1.default, { top: 0.25 }, children))));
};
exports.UserBadge.defaultProps = {
    center: 'auto',
    invert: false,
    size: 'xsmall'
};
exports.UserBadge.displayName = 'UserBadge';
exports.default = styles_1.withStyles(styles_2.default)(exports.UserBadge);
//# sourceMappingURL=UserBadge.js.map